// @ts-nocheck
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  Modal,
  Typography,
  useMediaQuery,
} from "@mui/material";
import styles from "../../../components/EventDetails/clientEmails.module.css";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useCallback, useMemo } from "react";
import { CustomInput } from "../../../components/Custom/Input";
import { CustomIconButton } from "../../../components/Custom/CustomIconButton";
import { Check, Close } from "@mui/icons-material";

const style = {
  boxShadow: 24,
  p: 4,
  pb: 0,
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
};

export const AddInvoiceEamils = ({ open, handleClose, type, addEmail, existingContacts = [] }) => {
  const { eventInfo, emailLoading } = useSelector(
    (state) => state?.eventRequestDetails,
  );

  const isEmailAlreadAdded = useCallback(
    (email) => existingContacts.some(item =>
      String(item?.[`${type}Email`] || '').trim().toLowerCase() === String(email || '').trim().toLowerCase(),
    ),
    [existingContacts, type],
  );

  const emailName = useMemo(() => {
    return `${type}Email`;
  }, [type]);

  const mobileName = useMemo(() => {
    return `${type}Mobile`;
  }, [type]);

  const initialValues = {
    [emailName]: "",
    name: "",
    [mobileName]: "",
  };

  const validationSchema = Yup.object().shape({
    [emailName]: Yup.string()
      .email("Must be valid email")
      .trim()
      .required("Email is required")
      .max(150, "An Email should be at most 150 characters.")
      .test("is-unique", "This email has already been added.", (value) => {
        if (!value) return true; // skip if empty; required() handles it
        return !isEmailAlreadAdded(value);
      }),
    name: Yup.string()
      .trim()
      .max(200, "Name should have at most 200 characters"),
    [mobileName]: Yup.string()
      .matches(/^\d{3}-\d{3}-\d{4}$/, { message: "Phone number must be of 10 digit", excludeEmptyString: true }),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      addEmail({ values: { ...values, [emailName]: values[emailName].trim().toLowerCase() }, type });
      onClose();
    },
  });

  const {
    handleChange,
    errors,
    touched,
    submitForm,
    handleBlur,
    values,
    resetForm,
  } = formik;

  function onClose() {
    handleClose();
    resetForm();
  }

  const handleMobileChange = (event) => {
    const input = event.target.value;
    const formattedInput = input
      .replace(/\D/g, "")
      .replace(/(\d{1,3})(\d{1,3})?(\d{1,4})?/, function (_, p1, p2, p3) {
        let formattedNumber = "";
        if (p1) {
          formattedNumber += p1;
        }
        if (p2) {
          formattedNumber += "-" + p2;
        }
        if (p3) {
          formattedNumber += "-" + p3;
        }
        return formattedNumber;
      });
    handleChange({
      target: {
        name: mobileName,
        value: formattedInput,
      },
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        gap: "1rem",
        "& input": {
          border: "none !important",
        },
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} md={12} lg={4}>
          <Box className={styles["form-box"]}>
            {/* <InputLabel>Name</InputLabel> */}
            <CustomInput
              fullWidth
              placeholder="Name (optional)"
              name="name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name}
            />
            {touched.name && errors.name && (
              <span className={styles["error"]}>{errors.name}</span>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Box className={styles["form-box"]}>
            {/* <InputLabel>Email</InputLabel> */}
            <CustomInput
              fullWidth
              placeholder="Email"
              name={emailName}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values?.[emailName]}
            />
            {touched?.[emailName] && errors?.[emailName] && (
              <span className={styles["error"]}>{errors?.[emailName]}</span>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Box className="form-box">
            {/* <InputLabel>Phone Number</InputLabel> */}
            <CustomInput
              fullWidth
              name={mobileName}
              value={values?.[mobileName]}
              onBlur={handleBlur}
              onChange={handleMobileChange}
              placeholder="Phone number (optional)"
            />
            {errors?.[mobileName] && touched?.[mobileName] && (
              <Typography variant="subtitle2" color="red">
                {errors?.[mobileName]}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-start",
          mt: 2,
          flexDirection: { md: "column", lg: "row" },
          gap: "0.25rem",
          "& button": {
            padding: "0",
          },
        }}
      >
        <CustomIconButton onClick={onClose}>
          <Close />
        </CustomIconButton>
        <CustomIconButton onClick={submitForm}>
          <Check />
        </CustomIconButton>
      </Box>
    </Box>
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className={styles["modal-container"]}
    >
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            ...style,
            width: "400px",
            maxHeight: "90vh",
            // minWidth: "300px",
            maxWidth: "1000px",
            overflowY: "auto",
            "@media (max-width: 600px)": {
              width: "90vw",
              maxHeight: "97vh",
              maxWidth: "95vw",
            },
          }}
          className="custom-scroll-design"
        >
          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography className={styles["title"]}>Add New Profile</Typography>

            <Box
              className="bottom-btn-box"
              sx={{
                width: "100%",
                marginTop: "2rem",
                alignSelf: "flex-end",
                marginBottom: " 2rem",
              }}
            >
              <Button
                className="btn-black"
                sx={{
                  width: "50%",
                  height: "3.25rem",
                  textTransform: "none !important",
                }}
                onClick={onClose}
              >
                <Typography className="btn-text">Close</Typography>
              </Button>

              <Button
                className="btn-pink"
                sx={{
                  width: "50%",
                  height: "3.25rem",
                  textTransform: "none !important",
                  "&:disabled": {
                    background: "#d85ad8 !important",
                  },
                }}
                onClick={submitForm}
              >
                {emailLoading ? (
                  <CircularProgress size={22} />
                ) : (
                  <Typography
                    sx={{ whiteSpace: "nowrap" }}
                    className="btn-text"
                  >
                    Add Profile
                  </Typography>
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
AddInvoiceEamils.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  type: PropTypes.string,
  addEmail: PropTypes.func,
  existingContacts: PropTypes.array,
};